/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ subtitle: NonNullable<unknown> }} Onboarding_Pilot_Ready_Preview_SubtitleInputs */



/**
* | output |
* | --- |
* | "Practice conversation · {subtitle}" |
*
* @param {Onboarding_Pilot_Ready_Preview_SubtitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_pilot_ready_preview_subtitle = /** @type {((inputs: Onboarding_Pilot_Ready_Preview_SubtitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Pilot_Ready_Preview_SubtitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Oefengesprek · ${i?.subtitle}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Entretien d’entraînement · ${i?.subtitle}`)
	return /** @type {LocalizedString} */ (`Practice conversation · ${i?.subtitle}`)
});